import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { PersonRelationType, PersonType } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export const getRelationLabelByTypeAndPersonType = (
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>,
	relationType: PersonRelationType,
	personType?: PersonType
) => {
	const isLegal = personType === PersonType.LEGAL;
	switch (relationType) {
		case PersonRelationType.PIV:
			return isLegal
				? tCapManage('basic_details.related_people.piv.title_legal')
				: tCapManage('basic_details.related_people.piv.title');
		case PersonRelationType.REPRESENTATIVE:
			return isLegal
				? tCapManage('basic_details.related_people.representatives.title_legal')
				: tCapManage('basic_details.related_people.representatives.title');
		case PersonRelationType.UBO:
			return isLegal
				? tCapManage('basic_details.related_people.ubo.title_legal')
				: tCapManage('basic_details.related_people.ubo.title');
		case PersonRelationType.PSC:
			return isLegal
				? tCapManage('basic_details.related_people.psc.title_legal')
				: tCapManage('basic_details.related_people.psc.title');
		case PersonRelationType.DIRECTOR:
			return isLegal
				? tCapManage('basic_details.related_people.director.title_legal')
				: tCapManage('basic_details.related_people.director.title');
		case PersonRelationType.TRUSTEE:
			return isLegal
				? tCapManage('basic_details.related_people.trustee.title_legal')
				: tCapManage('basic_details.related_people.trustee.title');
		case PersonRelationType.SETTLER_OR_GRANTOR:
			return isLegal
				? tCapManage('basic_details.related_people.settler_or_grantor.title_legal')
				: tCapManage('basic_details.related_people.settler_or_grantor.title');
		case PersonRelationType.PROTECTOR_OR_ENFORCER:
			return isLegal
				? tCapManage('basic_details.related_people.protector_or_enforcer.title_legal')
				: tCapManage('basic_details.related_people.protector_or_enforcer.title');
		case PersonRelationType.BENEFICIARY:
			return isLegal
				? tCapManage('basic_details.related_people.beneficiary.title_legal')
				: tCapManage('basic_details.related_people.beneficiary.title');
		case PersonRelationType.OTHER:
			return isLegal
				? tCapManage('basic_details.related_people.other.title_legal')
				: tCapManage('basic_details.related_people.other.title');
		default:
			return '';
	}
};
